import React, { useState, useContext } from 'react';
import classes from '../index.module.scss';
import { SearchContext } from '../../../context/Search';
import moment from 'moment';
import { HashLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom';
import DeleteReport from '../../FeedbackReports/DeleteReport'

const FeedbackReportsTableBody = () => {
  const { searchedData } = useContext(SearchContext);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState('');

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setDeleteId('');
  }

  const onDeleteReport = (e, id) => {
    setShowDeleteModal(true);
    setDeleteId(id);
    e.preventDefault();
  }
  
  return (
    <>
      {
        searchedData.map(item => {
          const { id, subject, email, name, replied_by, created } = item; 
          const date = moment(created).format('MM/DD/YYYY');
          const is_responded = !!replied_by; 

          return (
            <tr 
              key={id}
            >
              <td className={`${classes.Title_Bold} ${classes.Vertical_Middle}`}>{date}</td>
              <td className={`${classes.Title_Bold} ${classes.Vertical_Middle}`}>{name || "N/A"}</td>
              <td className={`${classes.Title_Normal} ${classes.Vertical_Middle} ${classes.Vertical_Middle_Email}`}>{email || "N/A"}</td>
              <td className={`${classes.Title_Normal} ${classes.Vertical_Middle}`}>{subject}</td>
              <td className={`${classes.Title_Normal} ${classes.Vertical_Middle}`}>
                <span 
                  className={`${is_responded ? "responded" : "not_responded"} general`}
                >
                  {is_responded ? "Responded" : "Not responded"}
                </span>
              </td>
              <td className={classes.Table_Options}>
                <Link
                  to={`/message?id=${id}&type=feedback&reply=0`}
                  className="btnSizes filledBtn"
                >
                  View
                </Link>
                <Link
                  to={`/message?id=${id}&type=feedback&reply=1`}
                  className="btnSizes transparentBtn ml-4"
                >
                  Reply
                </Link>
                <HashLink
                  onClick={(e) => onDeleteReport(e, id)}
                  to='#'
                  className="btnSizes defaultBtn ml-4"
                  smooth
                >
                  Delete
                </HashLink>
              </td>
            </tr> 
          )
        })
      }

    { showDeleteModal && <DeleteReport id={deleteId} closeDeleteModal={closeDeleteModal} showDelete={showDeleteModal}/> }

    </>
  )
}

export default FeedbackReportsTableBody;
 